import '@/assets/css'
import { createApp } from 'vue'
import i18n from './plugins/i18n'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import element from './plugins/element'
import directives from '@/directives'
import App from './App.vue'
import TableButton from './components/Table/install'
import './plugins/ali-arms'
import { globalBury } from './util/useBury'
import microApp from '@micro-zoe/micro-app'

microApp.start({
  'router-mode': 'pure'
})

createApp(App)
  .use(i18n)
  .use(globalBury)
  .use(store)
  .use(router)
  .use(axios)
  .use(element)
  .use(directives)
  .use(TableButton)
  .mount('#app')
